if (!customElements.get('td-faqs')) {
  class TDFaqs extends HTMLElement {
    connectedCallback() {
      if (this.dataset.tdFaqsReady === 'true') return;

      this.dataset.tdFaqsReady = 'true';
      this.items = Array.from(this.querySelectorAll('[data-td-faq-item]'));
      this.singleOpen = this.dataset.tdFaqsSingleOpen === 'true';
      this.onTriggerClick = this.onTriggerClick.bind(this);

      this.items.forEach((item) => {
        const trigger = item.querySelector('[data-td-faq-trigger]');

        if (!trigger) return;

        trigger.addEventListener('click', this.onTriggerClick);
      });
    }

    disconnectedCallback() {
      if (!this.items || !this.onTriggerClick) return;

      this.items.forEach((item) => {
        const trigger = item.querySelector('[data-td-faq-trigger]');

        if (!trigger) return;

        trigger.removeEventListener('click', this.onTriggerClick);
      });
    }

    onTriggerClick(event) {
      const item = event.currentTarget.closest('[data-td-faq-item]');

      if (!item) return;

      const isOpen = item.classList.contains('is-open');

      if (this.singleOpen) {
        this.items.forEach((otherItem) => {
          if (otherItem !== item) this.setState(otherItem, false);
        });
      }

      this.setState(item, !isOpen);
    }

    setState(item, expanded) {
      const trigger = item.querySelector('[data-td-faq-trigger]');
      const panel = item.querySelector('[data-td-faq-panel]');

      if (!trigger || !panel) return;

      item.classList.toggle('is-open', expanded);
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      panel.setAttribute('aria-hidden', expanded ? 'false' : 'true');
    }
  }

  customElements.define('td-faqs', TDFaqs);
}